export const HttpRequestMethod = {
    Get: 'GET',
    Post: 'POST',
    Options: 'OPTIONS',
};
export const ErrorType = {
    Unspecified: 'unspecified',
    ChainError: 'chain-error',
    ExecutionError: 'execution-error',
    NotFoundError: 'not-found-error',
    ValidationError: 'validation-error',
    WalletError: 'wallet-error',
    WalletNotInstalledError: 'wallet-not-installed-error',
    GrpcUnaryRequest: 'grpc-unary-request',
    HttpRequest: 'http-request',
    Web3: 'web3',
    Web3Gateway: 'web3-gateway',
};
